import React from "react";
import "./Analytics.css";

import useAnalytics from "./hooks/useAnalytics";

import AnalyticsCards from "./components/AnalyticsCards";
import RevenueChart from "./components/RevenueChart";
import OrdersChart from "./components/OrdersChart";
import TopFoods from "./components/TopFoods";
import CategorySales from "./components/CategorySales";
import CustomerStats from "./components/CustomerStats";
import PeakHours from "./components/PeakHours";

const Analytics = () => {
  const {
    dashboard,
    revenue,
    topFoods,
    categories,
    customers,
    peakHours,
    loading,
    error,
  } = useAnalytics();

  if (loading)
    return (
      <div className="analytics-loading">
        Loading Analytics...
      </div>
    );

  if (error)
    return (
      <div className="analytics-error">
        {error}
      </div>
    );

  return (
    <div className="analytics-page">

      <div className="analytics-header">

        <h1>📊 Business Analytics</h1>

        <p>
          Track your business performance,
          revenue, orders and customer insights.
        </p>

      </div>

      <AnalyticsCards dashboard={dashboard} />

      <div className="analytics-row">

        <RevenueChart revenue={revenue} />

        <OrdersChart revenue={revenue} />

      </div>

      <div className="analytics-row">

        <TopFoods foods={topFoods} />

        <CategorySales
          categories={categories}
        />

      </div>

      <div className="analytics-row">

        <CustomerStats
          customers={customers}
        />

        <PeakHours
          peakHours={peakHours}
        />

      </div>

    </div>
  );
};

export default Analytics;